import { render } from "./HeroiconsOutlineScale.vue?vue&type=template&id=318cc8b3"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineScale.vue"]])

export default __exports__